import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import StudentTopBar from './Components/StudentTopBar'
import CapeeshWebView, { appVersion } from '../../Components/AppWebGL/StudentCapeeshWeb/CapeeshWebView'
import useScreenSize from '../../Logic/useScreenSize'
import { history } from '_state/helpers'
import StudentAppOnboardingPage from './StudentAppOnboardingPage'
import StudentProfile from './StudentProfile'
import { CapeeshColors } from '../../assets/ColorPalette'
const useStyles = makeStyles((theme) => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
        backgroundColor: CapeeshColors.EggShell2,
        backgroundImage: 'radial-gradient(circle at 1px 1px, rgb(225, 225, 221) 1px, transparent 0)',
        backgroundSize: '12px 12px',
    },
    centeredCapeeshWebContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 60px)',
        width: '100%',
    },
    hideCapeeshWebContainer: {
        display: 'none',
    },
}))

import { StudentMonoPageSubPages, switchToStudentSubPage } from 'Logic/Student/StudentQueryParamParser'
import { FormattedMessage } from 'react-intl'
import GenericCapeeshWebModal from './Components/GenericCapeeshWebModal'
import { studentActions } from '../../_state/actions'

const StudentDashboard = (props) => {
    const classes = useStyles()

    const screenSize = useScreenSize()

    const [previewHeight, setPreviewHeight] = useState(screenSize.height * 0.85)
    const [previewWidth, setPreviewWidth] = useState(screenSize.height * 0.85 * 0.3)
    const [showPreviewBorder, setShowPreviewBorder] = useState(true)
    const [fitsToScreenEdges, setFitsToScreenEdges] = useState(false)
    const [backToRootWarningOpen, setBackToRootWarningOpen] = useState(false)
    const widthHeightMultiplier = 0.62

    const [currentSubPage, setCurrentSubPage] = useState(StudentMonoPageSubPages.PlayCapeeshApp)
    const [isInMobileView, setIsInMobileView] = useState(false)

    const maxHeight = 1000
    const maxWidth = maxHeight * widthHeightMultiplier

    const parseLocationSearchParameters = () => {
        const queryParamsSearch = props.location.search

        console.log('location changed', props.location.search)

        // pages to show on the same screen
        const showAppOnboardingFromParams = new URLSearchParams(queryParamsSearch).get('showAppOnboarding')
        const showStudentProfile = new URLSearchParams(queryParamsSearch).get('showStudentProfile')

        let showingSubPages = false

        if (showAppOnboardingFromParams === 'true') {
            setCurrentSubPage(StudentMonoPageSubPages.AppOnboarding)
            showingSubPages = true
        }
        if (showStudentProfile === 'true') {
            setCurrentSubPage(StudentMonoPageSubPages.Profile)
            showingSubPages = true
        }

        if (!showingSubPages) {
            setCurrentSubPage(StudentMonoPageSubPages.PlayCapeeshApp)
        }
    }

    useEffect(() => {
        parseLocationSearchParameters()
    }, [props.location.search])

    useEffect(() => {
        parseLocationSearchParameters()
    }, [])

    const recalculateCapeeshViewSize = () => {
        const topBarHeight = 60
        const magicCapeeshWidthLimiter = 0
        const magicCapeeshHeightLimiter = 0
        let width = previewWidth
        let height = previewHeight

        let isPortrait = true
        if (screenSize.height * 1.5 <= screenSize.width) {
            isPortrait = false
        }
        let isMobileView = false
        if (screenSize.width < maxWidth) {
            isMobileView = true
        }

        setIsInMobileView(isMobileView)

        if (screenSize.width <= maxWidth) {
            // less than max
            if (isPortrait) {
                width = screenSize.width
                height = screenSize.height - topBarHeight
                setFitsToScreenEdges(true)
            } else {
                height = screenSize.height - topBarHeight
                width = height * 0.3
            }
        } else {
            height = screenSize.height * 0.85
            width = height * widthHeightMultiplier
            setFitsToScreenEdges(false)
        }

        // sanity check
        if (width > screenSize.width - magicCapeeshWidthLimiter) {
            width = screenSize.width - magicCapeeshWidthLimiter
        }
        if (height > screenSize.height - magicCapeeshHeightLimiter - topBarHeight) {
            height = screenSize.height - magicCapeeshHeightLimiter - topBarHeight
        }
        if (isMobileView) {
            setShowPreviewBorder(false)
        } else {
            setShowPreviewBorder(true)
        }

        if (height !== previewHeight) {
            setPreviewHeight(height)
        }
        if (width !== previewWidth) {
            setPreviewWidth(width)
        }
    }

    const OnGoToRoot = () => {
        history.push('/student')
        document.dispatchEvent(new Event('GoToRoot'))
    }

    const handleWarnBackToRoot = () => {
        setBackToRootWarningOpen(true)
    }

    useEffect(() => {
        props.dispatch(studentActions.getStudentInfo(appVersion))

        recalculateCapeeshViewSize()
    }, [])

    useEffect(() => {
        recalculateCapeeshViewSize()
    }, [screenSize])

    const handleGoBakToCapeeshApp = () => {
        switchToStudentSubPage(StudentMonoPageSubPages.PlayCapeeshApp)
    }

    return (
        <React.Fragment>
            <GenericCapeeshWebModal
                open={backToRootWarningOpen}
                onClose={() => setBackToRootWarningOpen(false)}
                button1Text={<FormattedMessage id="globalwords.ok" defaultMessage={'Ok'} />}
                button2Text={<FormattedMessage id="globalwords.cancel" defaultMessage={'Cancel'} />}
                onButton2={() => setBackToRootWarningOpen(false)}
                onButton1={() => {
                    setBackToRootWarningOpen(false)
                    OnGoToRoot()
                }}
                textTitle={<FormattedMessage id="student.reload.warning.title" defaultMessage={'Warning'} />}
                content={
                    <FormattedMessage
                        id="student.reload.warning.text"
                        defaultMessage={'You will be sent back to the root of the main menu.'}
                    />
                }
            />
            <div className={classes.main}>
                <StudentTopBar
                    dispatch={props.dispatch}
                    onGoToRoot={handleWarnBackToRoot}
                    isInMobileView={isInMobileView}
                />
                <div
                    hidden={currentSubPage !== StudentMonoPageSubPages.PlayCapeeshApp}
                    className={`${fitsToScreenEdges ? '' : classes.centeredCapeeshWebContainer} ${currentSubPage !== StudentMonoPageSubPages.PlayCapeeshApp ? classes.hideCapeeshWebContainer : ''}`}>
                    <CapeeshWebView
                        student={props.student}
                        previewHeight={previewHeight}
                        previewWidth={previewWidth}
                        showBorder={showPreviewBorder}
                        urlLocation={props.location}
                    />
                </div>

                {currentSubPage === StudentMonoPageSubPages.AppOnboarding && (
                    <StudentAppOnboardingPage
                        onGoBakToCapeeshApp={handleGoBakToCapeeshApp}
                        studentEmail={props.student.userInfo.email}
                    />
                )}
                {currentSubPage === StudentMonoPageSubPages.Profile && (
                    <StudentProfile onGoBakToCapeeshApp={handleGoBakToCapeeshApp} />
                )}
            </div>
        </React.Fragment>
    )
}

StudentDashboard.propTypes = {}

const mapStateToProps = (state) => {
    const { student, studentAuth } = state
    return {
        student: student,
        studentAuth: studentAuth,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentDashboard)
